import { HttpInterceptorFn } from '@angular/common/http';

export const previewInterceptor: HttpInterceptorFn = (req, next) => {
  const previewEnv = window.previewEnvironment;
  if (previewEnv) {
    return next(
      req.clone({
        params: req.params.set('x-ms-routing-name', previewEnv),
      }),
    );
  }

  return next(req);
};
